import MundTauk from "../icons/MundTauk";
import TaukIcon from "../icons/Tauk";
import IntegrationTable from "@/components/shared/IntegrationTable/IntegrationTable";
import { integrationFieldPresets } from "@/components/shared/IntegrationTable/integrationFieldPresets";
import { useTranslation } from "react-i18next";

export default function Tauk() {
  const { t } = useTranslation("integration");

  return (
    <IntegrationTable
      integrationKey='tauk'
      title='Tauk'
      main_icon={<MundTauk />}
      icon={<TaukIcon />}
      fields={[
        integrationFieldPresets.postback_url,
        integrationFieldPresets.access_token,
        integrationFieldPresets.status,
      ]}
      fixedOptions={{
        active_statuses: [
          "not_authorized",
          "abandoned_cart",
          "awaiting_payment",
          "failed",
        ],
      }}
      fieldLabels={{
        access_token: "List ID",
        placeholder_access_token: t("tauk_placeholder_list_id"),
      }}
    />
  );
}
